import axios from 'axios'
import { AxiosResponse } from 'axios'
import { isFunction } from './utils'
import { ReqCfg, Options } from './types/api'
import { handleResponse, handleError } from './handlers'

const headers = {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json;charset=UTF-8'
}

const config = {
    headers,
    timeout: 3000,
    withCredentials: true
}

export default async (options: ReqCfg, apiOptions: Options = {}) => {
    const axiosConfig = Object.assign(config, (apiOptions.axiosConfig || {}))
    const fetch = axios.create(axiosConfig)
    try {
        const response: AxiosResponse = await fetch(options)
        if (options.intercept) {
            return response.data
        }
        if (apiOptions.handleResponse && isFunction(apiOptions.handleResponse)) {
            return apiOptions.handleResponse(response)
        } else {
            return handleResponse(response)
        }
    } catch (error: any) {
        if (options.intercept) {
            return Promise.reject(error)
        }

        if (apiOptions.handleError && isFunction(apiOptions.handleError)) {
            return apiOptions.handleError(error)
        } else {
            return handleError(error)
        }
    }
}